// Email send
export const EMAIL_LOADING = 'EMAIL_LOADING'
export const EMAIL_LOADING_COMPLETE = 'EMAIL_LOADING_COMPLETE'
export const EMAIL_RESET = 'EMAIL_RESET'
export const EMAIL_ERROR = 'EMAIL_ERROR'
export const EMAIL_ERROR_RESET = 'EMAIL_ERROR_RESET'

// Sidebar 
export const MOUSE_LEAVE = "MOUSE_LEAVE";
export const MOUSE_ENTER = "MOUSE_ENTER";

// Background Animation
export const ANIMATION_CHANGE = "ANIMATION_CHANGE";

// Settings - Sound
export const SOUND_ON = "SOUND_ON";
export const SOUND_OFF = "SOUND_OFF";

// Settings - Dark Mode
export const DARK_MODE_ON = "DARK_MODE_ON";
export const DARK_MODE_OFF = "DARK_MODE_OFF";

// Music
export const MUSIC_ON = "MUSIC_ON";
export const MUSIC_OFF = "MUSIC_OFF";

// Auth 
export const USER_LOADED = "USER_LOADED";
export const AUTH_ERROR = "AUTH_ERROR";
export const LOADING_FALSE = "LOADING_FALSE";

export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGIN_LOADING_COMPLETE = "LOGIN_LOADING_COMPLETE";
export const LOGIN_LOADING = "LOGIN_LOADING";

export const LOGOUT = "LOGOUT";

// Different Errors for the snackbar
export const SNACKBAR_RESET = 'SNACKBAR_RESET'
export const ERROR_400 = 'ERROR_400'
export const ERROR_401 = 'ERROR_401'
export const ERROR_500 = 'ERROR_500'
export const SUCCESS_200 = 'SUCCESS_200'
export const ERROR_SOMETHING_ELSE = 'ERROR_SOMETHING_ELSE'
export const ERROR_SNACKBAR = 'ERROR_SNACKBAR'

// Metrics - Visitor Pie Chart
export const VISITOR_PIE_CHART = 'VISITOR_PIE_CHART'
export const VISITOR_PIE_CHART_LOADING = "VISITOR_PIE_CHART_LOADING";
export const VISITOR_PIE_CHART_LOADING_COMPLETE = "VISITOR_PIE_CHART_LOADING_COMPLETE";

// Metrics - Total Hits Block
export const TOTAL_HITS_BLOCK = 'TOTAL_HITS_BLOCK'
export const TOTAL_HITS_BLOCK_LOADING = "TOTAL_HITS_BLOCK_LOADING";
export const TOTAL_HITS_BLOCK_LOADING_COMPLETE = "TOTAL_HITS_BLOCK_LOADING_COMPLETE";

// Metrics  - Total Hit CHART
export const TOTAL_HITS_CHART_LOADING = "TOTAL_HITS_CHART_LOADING";
export const TOTAL_HITS_CHART_LOADING_COMPLETE = "TOTAL_HITS_CHART_LOADING_COMPLETE";
export const TOTAL_HITS_CHART = "TOTAL_HITS_CHART";

// Metrics  - Total Cold Message
export const TOTAL_COLD_MESSAGE_LOADING = "TOTAL_COLD_MESSAGE_LOADING";
export const TOTAL_COLD_MESSAGE_LOADING_COMPLETE = "TOTAL_COLD_MESSAGE_LOADING_COMPLETE";
export const TOTAL_COLD_MESSAGE = "TOTAL_COLD_MESSAGE";

// Metrics  - Total Ongoing Message
export const TOTAL_ONGOING_MESSAGE_LOADING = "TOTAL_ONGOING_MESSAGE_LOADING";
export const TOTAL_ONGOING_MESSAGE_LOADING_COMPLETE = "TOTAL_ONGOING_MESSAGE_LOADING_COMPLETE";
export const TOTAL_ONGOING_MESSAGE = "TOTAL_ONGOING_MESSAGE";

// Metrics  - Total Success Message
export const TOTAL_SUCCESS_MESSAGE = "TOTAL_SUCCESS_MESSAGE";
export const TOTAL_SUCCESS_MESSAGE_LOADING = "TOTAL_SUCCESS_MESSAGE_LOADING";
export const TOTAL_SUCCESS_MESSAGE_LOADING_COMPLETE = "TOTAL_SUCCESS_MESSAGE_LOADING_COMPLETE";

// Metrics  - Total Not Replied Message
export const TOTAL_NOT_REPLIED_MESSAGE = "TOTAL_NOT_REPLIED_MESSAGE";
export const TOTAL_NOT_REPLIED_MESSAGE_LOADING = "TOTAL_NOT_REPLIED_MESSAGE_LOADING";
export const TOTAL_NOT_REPLIED_MESSAGE_LOADING_COMPLETE = "TOTAL_NOT_REPLIED_MESSAGE_LOADING_COMPLETE";

// Metrics  - Total Hits Synopsis
export const TOTAL_HITS_SYNOPSIS_TODAY = "TOTAL_HITS_SYNOPSIS_TODAY";
export const TOTAL_HITS_SYNOPSIS_WEEK = "TOTAL_HITS_SYNOPSIS_WEEK";
export const TOTAL_HITS_SYNOPSIS_MONTH = "TOTAL_HITS_SYNOPSIS_MONTH";
export const TOTAL_HITS_SYNOPSIS_YEAR = "TOTAL_HITS_SYNOPSIS_YEAR";
export const TOTAL_HITS_SYNOPSIS_ALL_TIME = "TOTAL_HITS_SYNOPSIS_ALL_TIME";
export const TOTAL_HITS_SYNOPSIS_LOADING = "TOTAL_HITS_SYNOPSIS_LOADING";
export const TOTAL_HITS_SYNOPSIS_LOADING_COMPLETE = "TOTAL_HITS_SYNOPSIS_LOADING_COMPLETE";
export const TOTAL_HITS_TYPE = "TOTAL_HITS_TYPE";

// Metrics - Recent Messages
export const RECENT_MESSAGES_LIMIT = "RECENT_MESSAGES_LIMIT";
export const RECENT_MESSAGES_LIMIT_LOADING = "RECENT_MESSAGES_LIMIT_LOADING";
export const RECENT_MESSAGES_LIMIT_LOADING_COMPLETE = "RECENT_MESSAGES_LIMIT_LOADING_COMPLETE";

// Messages - Retrieve
export const MESSAGES = "MESSAGES";
export const MESSAGES_ON_RELOAD = "MESSAGES_ON_RELOAD";
export const MESSAGES_LOADING = "MESSAGES_LOADING";
export const MESSAGES_LOADING_COMPLETE = "MESSAGES_LOADING_COMPLETE";
export const MESSAGES_OLDEST = "MESSAGES_OLDEST";
export const MESSAGES_OLDEST_RESET = "MESSAGES_OLDEST_RESET";
export const MESSAGES_RESET = "MESSAGES_RESET";
export const MESSAGES_ON_RELOAD_OLDEST = "MESSAGES_ON_RELOAD_OLDEST";
export const COMMENT_ON_MESSAGE = "COMMENT_ON_MESSAGE";

// Messages - Set Count 
export const SET_MESSAGES_TOTAL_COUNT = "SET_MESSAGES_TOTAL_COUNT";
export const SET_MESSAGES_UNSEEN_COUNT = "SET_MESSAGES_UNSEEN_COUNT";


// Messages - Update Status
export const UPDATE_MESSAGE_STATUS = "UPDATE_MESSAGE_STATUS";

// Messages - Delete
export const REMOVE_MESSAGE_FROM_ARRAY = "REMOVE_MESSAGE_FROM_ARRAY";

// Set Renderer Message 
export const SET_RENDERER_MESSAGE_FALSE = "SET_RENDERER_MESSAGE_FALSE";
export const SET_RENDERER_MESSAGE_TRUE = "SET_RENDERER_MESSAGE_TRUE";
export const SET_MESSAGES_UNSEEN_COUNT_INCREASE = "SET_MESSAGES_UNSEEN_COUNT_INCREASE";

// Blog
export const BLOG_CHECK_AUTH_LOADING = "BLOG_CHECK_AUTH_LOADING";
export const BLOG_CHECK_AUTH = "BLOG_CHECK_AUTH";